import { c as _c } from "react/compiler-runtime";
import { useQuery } from "@tanstack/react-query";
import { queryKeys } from "@/queries/query-keys";
import { departmentApi } from "@/services/api/internal/department/department-api";
import { DepartmentRead } from "@/TS/Interfaces/global_interfaces";
export function useDepartments() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      queryKey: queryKeys.departments,
      queryFn: _temp,
      staleTime: 3600000
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return useQuery(t0);
}
async function _temp() {
  const result = await departmentApi.getDepartments();
  return result;
}